'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('antd/lib/rate/style/css');

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Rate = (0, _component2.default)(function () {
    return import("antd/lib/rate");
});

var IDRate = function (_BaseComponent) {
    (0, _inherits3.default)(IDRate, _BaseComponent);

    function IDRate() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, IDRate);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IDRate.__proto__ || (0, _getPrototypeOf2.default)(IDRate)).call.apply(_ref, [this].concat(args))), _this), _this.dataTestID = 'rate', _this.handleChange = function (value) {
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                readOnly = _this$props.readOnly;

            if (disabled || readOnly) {
                return;
            }
            _this.setValue(value);
        }, _this.handleBlur = function () {
            var value = _this.getValue();
            _this.props.onBlur && _this.props.onBlur(value);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(IDRate, [{
        key: 'render',
        value: function render() {
            var value = this.state.value;

            return _react2.default.createElement(
                'div',
                {
                    'data-testid': this.getDataTestId(),
                    style: { display: 'inline-block' }
                },
                _react2.default.createElement(Rate, (0, _extends3.default)({}, this.props, {
                    value: value,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur
                }))
            );
        }
    }]);
    return IDRate;
}(_BaseComponent3.default);

exports.default = IDRate;